import Service from "../service";

class CustomerRatingService extends Service {
  async getCustomerRating(customerOrgId) {
    if (customerOrgId) {
      const requestOptions = {
        method: 'GET',
        headers: { 
          'Content-Type': 'application/json', 
          'Accept': 'application/json'
        }
      };

      //TODO переделать?
      const baseURL = process.env.REACT_APP_ENVIRONMENT === 'Production' ? process.env.REACT_APP_ORGANIZATIONS_API_URI : 'http://localhost:5560';
      return await this.authenticatedFetch(`${baseURL}/api/review/rating/${customerOrgId}`, requestOptions);
    }
    return null;
  }

  async getCustomerRatings(customerOrgIds) {
    if (customerOrgIds)
    {
      const requestOptions = {
        method: 'POST',
        headers: { 
          'Content-Type': 'application/json', 
          'Accept': 'application/json'
        },
        body: JSON.stringify(customerOrgIds)
      };

      //TODO переделать?
      const baseURL = process.env.REACT_APP_ENVIRONMENT === 'Production' ? process.env.REACT_APP_ORGANIZATIONS_API_URI : 'http://localhost:5560';
      return await this.authenticatedFetch(`${baseURL}/api/review/ratings`, requestOptions);
    }
    return null;
  }

  async SendReview(reviewOptions) {
    const requestOptions = {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      },
      body: JSON.stringify(reviewOptions)
    };

    const baseURL = process.env.REACT_APP_ENVIRONMENT === 'Production' ? process.env.REACT_APP_CUSTOMER_RATING_API_URI : 'http://localhost:5560';
    var response = await fetch(`${baseURL}/api/review`, requestOptions);   
    if (response.status === 200)
    {
      return true;
    }
    return false;
  }

  async GetReviewRequest(requestId) {
    const requestOptions = {
      method: 'GET',
      headers: { 
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      }
    };

    const baseURL = process.env.REACT_APP_ENVIRONMENT === 'Production' ? process.env.REACT_APP_CUSTOMER_RATING_API_URI : 'http://localhost:5560';
    const encodedRequestId = encodeURIComponent(requestId);
    const response = await fetch(`${baseURL}/api/review/${encodedRequestId}`, requestOptions);
    if (response.status === 200)
    {
      const reviewRequest = await response.json();
      return reviewRequest;
    }
    return null;
  }

  async GetReviews(options) {
    const requestOptions = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify(options)
    };

    const baseURL = process.env.REACT_APP_ENVIRONMENT === 'Production' ? process.env.REACT_APP_CUSTOMER_RATING_API_URI : 'http://localhost:5560';
    return await this.authenticatedFetch(`${baseURL}/api/review/page`, requestOptions);
  }
}

export default new CustomerRatingService();